/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Verify_TitleInputs */

const he_seo_verify_title = /** @type {(inputs: Seo_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אימות חשבון - Pricedrop`)
};

const en_seo_verify_title = /** @type {(inputs: Seo_Verify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify Account - Pricedrop`)
};

/**
* | output |
* | --- |
* | "Verify Account - Pricedrop" |
*
* @param {Seo_Verify_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_verify_title = /** @type {((inputs?: Seo_Verify_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Verify_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_verify_title(inputs)
	return en_seo_verify_title(inputs)
});